import { z } from 'zod';
import { applicationDateOrder, idArray, paymentReportsFilterSchema, transactionDateOrder } from './shared.schema';

export const taxReportFormatSchema = z.enum(['csv', 'pdf', 'xlsx']);

const dateOrderSchema = z.discriminatedUnion('dateOrder', [transactionDateOrder, applicationDateOrder]);

const commonFields = z.object({
	accountFilter: paymentReportsFilterSchema.optional(),
	hideZeroDollarColumns: z.boolean().default(true),
	areaIds: idArray.optional(),
	branchIds: idArray.optional(),
	districtIds: idArray.optional(),
	facilityIds: z.array(z.string()).optional(),
	format: taxReportFormatSchema.default('csv'),
	facilityNumber: z.union([z.string(), z.number()]).optional(),
});

export const taxParametersSchema = z.intersection(commonFields, dateOrderSchema).superRefine((value, ctx) => {
	if (value.format === 'pdf' && !value.hideZeroDollarColumns) {
		ctx.addIssue({
			code: 'custom',
			path: ['hideZeroDollarColumns'],
			message: 'The PDF Tax Report requires Hide Zero Dollar Columns to be enabled',
		});
	}

	if (value.dateOrder === 'transactionDate' && value.applicationEndDate && !value.applicationStartDate) {
		ctx.addIssue({
			code: 'custom',
			path: ['applicationEndDate'],
			message: 'Cannot specify an Application End Date without an Application Start Date',
		});
	}

	if (value.dateOrder === 'applicationDate' && value.transactionEndDate && !value.transactionStartDate) {
		ctx.addIssue({
			code: 'custom',
			path: ['transactionEndDate'],
			message: 'Cannot specify a Transaction End Date without a Transaction Start Date',
		});
	}
});

export type TaxParameters = z.infer<typeof taxParametersSchema>;
export type TaxReportFormat = z.infer<typeof taxReportFormatSchema>;
